<template>
  <b-container class="categories-container" v-if="isActiveSection" fluid>
    <b-row
      v-for="({ name, link, id }, index) in categories"
      :key="id"
      class="mt-2"
    >
      <b-card no-body class="">
        <b-card-header header-tag="header" class="awards-categories-main-cont p-1" role="tab">
          <div class="pl-2">{{ name }}</div>
          <div
            class="awards-categories-icon-cont"
            v-b-toggle="`accordion-${id}`"
            @click="showIcon(index)"
          >
            <i v-if="categories[index].show"
              class="fa fa-minus awards-categories-icon"
            />
            <i v-else class="fa fa-plus awards-categories-icon" />
          </div>
        </b-card-header>
        <b-collapse :id="`accordion-${id}`" accordion="my-accordion" role="tabpanel">
          <b-card-body>{{link}}</b-card-body>
        </b-collapse>
      </b-card>
    </b-row>
  </b-container>
  <div v-else style="text-align: center; color: #BD9D5F">The section is not available now and coming soon...</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  data() {
    return {
      categories: [],
    };
  },
  computed: {
    ...mapGetters({
      award: 'awards/award',
    }),
    isActiveSection() {
      return this.award && this.award.available_sections ? this.award.available_sections.includes('categories') : false;
    },
  },
  async mounted() {
    if (this.$route.params.awardId) {
      this.categories = await this.fetchCategories(this.$route.params.awardId);
    }
  },
  methods: {
    ...mapActions({
      fetchCategories: 'awards/fetchCategories',
    }),
    showIcon(index) {
      const categories = this.$lodash.cloneDeep(this.categories);
      categories[index].show = !categories[index].show;
      this.categories = categories;
    },
  },
};
</script>

<style scoped>
.awards-categories-name-text {
  color: #bd9d5f;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.awards-categories-collapse-main-cont {
  width: 100%;
}
.awards-categories-collapse-cont {
  margin-top: 1px;
  background-color: #ffffff;
  padding: 10px;
  font-family: Arial;
  font-size: 13px;
  line-height: 1.15;
  text-align: left;
  color: #333333;
}
.awards-categories-main-cont {
  background-color: white;
  display: flex;
  justify-content: space-between;
}
.awards-categories-icon-cont {
  margin-left: auto;
}
.awards-categories-icon {
  color: white;
  background-color: #BD9D5F;
  padding: 5px;
  font-size: 10px;
  cursor: pointer;
}
.card {
  width: 100%;
}
@media (max-width: 1024px) {
  .categories-container>.row {
    border-radius: 0 10px 10px 10px;
    overflow: hidden;
  }
  .awards-categories-name-text {
    font-size: 12px;
  }
  .awards-categories-icon-cont i {
    border-radius: 0 6px 6px 6px;
  }
}
</style>
